import {
  create_project_type,
  update_project_type,
  delete_project_type,
  recover_project_type,
  query_project_type_list,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-projecttype-config';

import { reactive } from 'vue';
import {get_is_active, get_is_active2, toFixed0} from '@/utils/function';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '项目分类编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写项目分类编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '项目分类名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写项目分类名称',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    name: null,
    code: null,
    p_type: null,
  }),
};
const search_options = {
  p_type: [
    { value: 0, name: '面部单' },
    { value: 10, name: '身体单' },
    { value: 20, name: '产品单' },
    { value: 1, name: '次数卡' },
    { value: 11, name: '时间卡' },
    { value: 21, name: '产品卡' },
    { value: 2, name: '套餐' },
    { value: 30, name: '外科单' },
  ],
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '项目分类编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写项目分类编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '项目分类名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写项目分类名称',
    },
    {
      type: 'radio',
      name: 'p_type',
      label: '类型',
      disabled: false,
      allowClear: true,
      labelKey: 'name',
      valueKey: 'value',
      defaultValue: '',
      placeholder: '请选择类型',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入项目分类' }],
    code: [{ required: true, message: '请填输入项目分类编号' }],
    p_type: [{ required: true, message: '请选择类型' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    code: null,
    p_type: null,
  }),
};
const edit_model_config_options = {
  p_type: [
    { value: 0, name: '面部单' },
    { value: 10, name: '身体单' },
    { value: 20, name: '产品单' },
    { value: 1, name: '次数卡' },
    { value: 11, name: '时间卡' },
    { value: 21, name: '产品卡' },
    { value: 2, name: '套餐' },
    { value: 30, name: '外科单' },
  ],
};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '项目分类编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写项目分类编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '项目分类名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写项目分类名称',
    },

    {
      type: 'radio',
      name: 'p_type',
      label: '类型',
      disabled: false,
      allowClear: true,
      labelKey: 'name',
      valueKey: 'value',
      defaultValue: '',
      placeholder: '请选择类型',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入项目分类' }],
    code: [{ required: true, message: '请填输入项目分类编号' }],
    p_type: [{ required: true, message: '请选择类型' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    code: null,
    p_type: null,
  }),
};
const update_model_config_options = {
  p_type: [
    { value: 0, name: '面部单' },
    { value: 10, name: '身体单' },
    { value: 20, name: '产品单' },
    { value: 1, name: '次数卡' },
    { value: 11, name: '时间卡' },
    { value: 21, name: '产品卡' },
    { value: 2, name: '套餐' },
    { value: 30, name: '外科单' },
  ],
};

const titleList = {
  title: '项目分类管理',
  addModalTitle: '新建项目分类',
  updateTitle: '修改项目分类',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    projecttype_id: 'id',
  },
  delete: {
    projecttype_id: 'id',
  },
  recover: {
    projecttype_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    projecttype_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    width: 50,
    dataIndex: 'index',
  },
  {
    title: '项目分类编号',
    dataIndex: 'code',
    checked: true,
  },
  {
    title: '项目分类名称',
    dataIndex: 'name',
    checked: true,
  },
  {
    title: '类型',
    dataIndex: 'p_type',
    checked: true,
    slots: { customRender: 'p_type' },
    filterMultiple: false,
    filters: [
      { text: '面部单', value: 0 },
      { text: '身体单', value: 10 },
      { text: '产品单', value: 20 },
      { text: '次数卡', value: 1 },
      { text: '时间卡', value: 11 },
      { text: '产品卡', value: 21 },
      { text: '套餐', value: 2 },
      { text: '外科单', value: 30 },
    ],
    content: (record: any, text: any) => {
      const dict: any = {
        0: '面部单',
        10: '身体单',
        20: '产品单',
        1: '次数卡',
        11: '时间卡',
        21: '产品卡',
        2: '套餐',
        30: '外科单',
      };
      return dict[text];
    },
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'is_active',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push(
  {
    type: 'custom',
    // slotName: 'is_active',
    field_true: '可用',
    field_false: '作废',
  },
  {
    type: 'custom',
    slotName: 'p_type',
    field_0: '面部单',
    field_10: '身体单',
    field_20: '产品单',
    field_1: '次数卡',
    field_11: '时间卡',
    field_21: '产品卡',
    field_2: '套餐',
    field_30: '外科单',
  },
);

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_project_type_list,
    addData: create_project_type,
    updateData: update_project_type,
    removeData: delete_project_type,
    recoverData: recover_project_type,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
